/**
 * What an artifact *is*, lowercased for use mid-sentence — "you don't have
 * access to this document", "this dataset is archived".
 *
 * Almost every artifact type is already its own label (`document`, `dataset`,
 * `workflow`), so this only names the two that are not: the hyphenated types
 * would otherwise reach a sentence as "this chart-dashboard is archived".
 *
 * Distinct from {@link artifactKindLabel}, which is the Title Case name a row
 * in the artifacts index is captioned with. Same fact, different grammar — a
 * label that starts a phrase and one that sits inside a sentence cannot be the
 * same string, and this is the half the notices need.
 */
const ARTIFACT_TYPE_LABELS: Record<string, string> = {
  'chart-dashboard': 'dashboard',
  'workflow-node': 'workflow step',
};

export const artifactTypeLabel = (artifactType: string): string =>
  ARTIFACT_TYPE_LABELS[artifactType] ?? artifactType;
